import { Button, Flex, Form, FormInstance, Modal, Radio, Row, Spin } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import iconDropOff from '../../assets/images/booking/icon-drop-off.svg';
import iconPickup from '../../assets/images/booking/icon-pickup.svg';
import '../../assets/styles/desktop/busBooking.scss';
import { Constant, DateFormat, USER_GROUP } from '../../config/constant';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { selectAuth } from '../../redux/slice/authSlice';
import { createBookingV2 } from '../../redux/slice/bookings/createBookingSlice';
const ModalExportTicket: React.FC<any> = ({
  okText,
  cancelText,
  modalOpen,
  onCancel,
  onOk,
  listBookingDetail,
  isDetail,
  listBooking,
  loadingDetailList,
  searchDateBooking,
}: any) => {
  const dispatch = useAppDispatch();
  const { group } = useAppSelector(selectAuth);
  const [formExportTicket]: [FormInstance] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(modalOpen);

  useEffect(() => {
    setIsModalOpen(modalOpen);
  }, [modalOpen]);

  const getPaymentOptions = () => {
    if (group === USER_GROUP.AGENT) {
      return [
        {
          label: 'Tài khoản đại lý',
          value: 'agent_balance',
          disabled: false,
        },
        {
          label: 'Tại nhà xe',
          value: 'paid_at_company',
          disabled: false,
        },
      ];
    } else {
      return [
        {
          label: 'Tiền mặt',
          value: 'cash',
          disabled: false,
        },
        {
          label: 'Chuyển khoản ngân hàng',
          value: 'bank_transfer',
          disabled: false,
        },
      ];
    }
  };
  const options = getPaymentOptions();

  const modalHandleOk = () => {
    onOk();
  };
  const onFinish = (values: any) => {
    if (values.payment_method) {
      const dataCreateBooking = {
        seat_number: listBookingDetail?.seat_number,
        booking_type: Constant.BOOKING_SINGLE,
        ticket_code: listBookingDetail?.ticket_code,
        customer_name: listBookingDetail?.customer?.name,
        customer_phone: listBookingDetail?.customer?.phone,
        customer_email: listBookingDetail.customer?.email,
        is_diagram: listBooking?.schedule?.is_diagram,
        pickup_location_id: listBookingDetail?.pickup_extra ? undefined : listBookingDetail?.pickup_location?.id,
        drop_off_location_id: listBookingDetail.drop_off_extra ? undefined : listBookingDetail.drop_off_location?.id,
        pickup_extra: listBookingDetail?.pickup_extra ?? undefined,
        drop_off_extra: listBookingDetail?.drop_off_extra ?? undefined,
        payment_method: values.payment_method,
        is_insurance: listBookingDetail?.is_insurance ? listBookingDetail?.is_insurance : false,
        note: listBookingDetail?.note,
        depart_date: searchDateBooking,
        schedule_id: listBookingDetail?.schedule_id,
        booking_for_agent: listBookingDetail?.booking_for_agent ? true : false,
        agent_id: listBookingDetail?.booking_for_agent ? listBookingDetail?.booking_for_agent : undefined,
        segment_id: listBookingDetail?.segment_id,
      };
      dispatch(createBookingV2(dataCreateBooking));
    } else {
      toast.error('Vui lòng nhập phương thức thanh toán');
    }
  };

  const modalHandleCancel = () => {
    onCancel();
    formExportTicket.resetFields();
  };
  return (
    <Modal
      closeIcon={false}
      open={isModalOpen}
      onOk={modalHandleOk}
      onCancel={modalHandleCancel}
      cancelText={cancelText}
      okText={okText}
      footer={[]}
      closable={true}
      width={680}
      maskClosable={false}
      className="modal-export-ticket"
      centered
    >
      <Spin spinning={loadingDetailList}>
        <Form
          className="mg-16"
          form={formExportTicket}
          labelCol={{ xxl: 5, xl: 6, lg: 7, md: 24, sm: 24 }}
          requiredMark={false}
          onFinish={onFinish}
          colon={false}
        >
          <div>
            <h4 className="fs-18 fw-600 border-b" style={{ color: '#444' }}>
              Xuất vé
            </h4>
            <Flex gap={20} className="mt-1">
              <p className="fs-16 fw-500 text-blue">
                Mã vé: <span className="fs-16 fw-600 text-blue">{listBookingDetail?.ticket_code}</span>
              </p>
              <p>
                Họ và tên: <span className="fs-16 fw-600 text-blue">{listBookingDetail?.customer?.name}</span>
              </p>
              <p>
                Số điện thoại: <span className="fs-16 fw-600 text-blue">{listBookingDetail?.customer?.phone}</span>
              </p>
            </Flex>
          </div>
          <div className="modal-export-content mt-3">
            <div className="bg-segment">
              <p className="fs-16 fw-600 text-white">
                Chặng: {`${listBookingDetail?.start_location} - ${listBookingDetail?.end_location}`}
              </p>
            </div>
            <Flex gap={8} align="flex-start" className="mt-3">
              <img src={iconPickup} alt="" />
              <div>
                {listBookingDetail?.pickup_location?.id ? (
                  <>
                    <p className="fs-16 fw-500 text-blue">
                      {`${
                        listBookingDetail?.pickup_location?.location_name
                      } (${listBookingDetail?.pickup_location?.time?.slice(0, 5)} - ${dayjs(
                        listBooking?.travel_info?.depart_date,
                      )
                        ?.add(listBookingDetail?.pickup_location?.diff_day, 'day')
                        ?.format(DateFormat)})`}
                    </p>
                    <p className="fs-14 fw-500" style={{ color: '#667085' }}>
                      {listBookingDetail?.pickup_location?.address}
                    </p>
                  </>
                ) : (
                  <>
                    <p className="fs-16 fw-500 text-blue">{listBookingDetail?.pickup_extra}</p>
                  </>
                )}
              </div>
            </Flex>
            <Flex className="mt-3" gap={8} align="flex-start">
              <img src={iconDropOff} alt="" />
              <div>
                {listBookingDetail?.drop_off_location?.id ? (
                  <>
                    <p className="fs-16 fw-500 text-blue">
                      {`${
                        listBookingDetail?.drop_off_location?.location_name
                      } (${listBookingDetail?.drop_off_location?.time?.slice(0, 5)} - ${dayjs(
                        listBooking?.travel_info?.depart_date,
                      )
                        ?.add(listBookingDetail?.drop_off_location?.diff_day, 'day')
                        ?.format(DateFormat)})`}
                    </p>
                    <p className="fs-14 fw-500" style={{ color: '#667085' }}>
                      {listBookingDetail?.drop_off_location?.address}
                    </p>
                  </>
                ) : (
                  <>
                    <p className="fs-16 fw-500 text-blue">{listBookingDetail?.drop_off_extra}</p>
                  </>
                )}
              </div>
            </Flex>
            <p className="fs-14 fw-500 text-blue mt-2">{`${
              listBookingDetail?.note ? `* ${listBookingDetail?.note}` : ''
            }`}</p>
            <p className="mt-3 fs-16 fw-600 text-blue">
              {`Giá vé: `}
              <span>
                {listBookingDetail?.price_change ? listBookingDetail?.price_change : listBookingDetail?.final_price}
              </span>
              <span className="text-success fs-14 fw-500">{`${
                listBookingDetail?.is_insurance ? '(đã bao gồm 5000đ tiền bảo hiểm)' : ''
              } `}</span>
            </p>
            <p className="fs-14 fw-500 text-blue"> Người đặt: {`${listBookingDetail?.orderer?.name}`}</p>
          </div>
          <div className="mt-3">
            <p className="fs-16 fw-500 text-blue">
              Vui lòng chọn phương thức thanh toán <span className="red">*</span>
            </p>
            <Form.Item
              name="payment_method"
              className="require mt-2"
              required={true}
              validateTrigger={['onChange', 'onBlur']}
            >
              <Radio.Group
                options={options}
                buttonStyle="solid"
                className={`payment-checkbox-group mt-1 ${isDetail ? 'detail' : ''}`}
                disabled={
                  isDetail &&
                  (listBookingDetail?.payment_method === 'cash' ||
                    listBookingDetail?.payment_method === 'bank_transfer' ||
                    listBookingDetail?.payment_method === 'agent_balance')
                }
              />
            </Form.Item>
          </div>

          <Row className="d-flex justify-content-end mt-3">
            <>
              <Button
                key="ok"
                type="primary"
                className="btn-export-ticket mr-0 d-flex align-center text-white"
                style={{ justifyContent: 'center' }}
                htmlType="submit"
              >
                {'Xuất vé'}
              </Button>
            </>
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
};

export default ModalExportTicket;
